// Enums baseados nos DTOs fornecidos
export enum ActivityCategory {
  FITNESS = 'Fitness',
  SPORTS = 'Sports',
  ENTERTAINMENT = 'Entertainment',
  ADVENTURE = 'Adventure',
  AQUATIC = 'Aquatic',
  RECREATION = 'Recreation',
  WELLNESS = 'Wellness',
  GASTRONOMY = 'Gastronomy',
  CULTURAL = 'Cultural',
  KIDS = 'Kids',
}

export type FormDataType = {
  title: string
  description: string
  period: string
  time: string
  location: string
  capacity: string
  category: ActivityCategory
  ageGroup: AgeGroup
  price: string
  titleFreePrice?: string
  order?: number | string
  requiresReservation: boolean
  isActive: boolean
}

export enum AgeGroup {
  CHILDREN = 'children',
  ADULTS = 'adults',
  FAMILY = 'family',
  TEENS = 'teens',
  SENIORS = 'seniors',
}

export type HotelActivityType = {
  id: number
  pluginspaceId: number
  title: string
  description: string
  time: string
  location: string
  capacity: string
  order: number
  image: string
  category: ActivityCategory
  ageGroup?: AgeGroup
  price?: number
  requiresReservation?: boolean
  isActive?: boolean
  createdAt?: string
  updatedAt?: string
}

export type CreateHotelActivityDto = {
  title: string
  description: string
  time: string
  location: string
  capacity: string
  image: string
  category: ActivityCategory
  ageGroup?: AgeGroup
  price?: number
  requiresReservation?: boolean
  isActive?: boolean
}

export type UpdateHotelActivityDto = {
  title?: string
  description?: string
  time?: string
  location?: string
  capacity?: string
  image?: string
  category?: ActivityCategory
  ageGroup?: AgeGroup
  price?: number
  requiresReservation?: boolean
  isActive?: boolean
}

// Funções utilitárias para labels
export const getCategoryLabel = (category: ActivityCategory): string => {
  const categoryLabels: Record<ActivityCategory, string> = {
    [ActivityCategory.FITNESS]: 'Fitness',
    [ActivityCategory.SPORTS]: 'Esporte',
    [ActivityCategory.ENTERTAINMENT]: 'Entretenimento',
    [ActivityCategory.ADVENTURE]: 'Aventura',
    [ActivityCategory.AQUATIC]: 'Aquático',
    [ActivityCategory.RECREATION]: 'Recreação',
    [ActivityCategory.WELLNESS]: 'Bem-estar',
    [ActivityCategory.GASTRONOMY]: 'Gastronomia',
    [ActivityCategory.CULTURAL]: 'Cultural',
    [ActivityCategory.KIDS]: 'Infantil',
  }
  return categoryLabels[category] || category
}

export const getAgeGroupLabel = (ageGroup: AgeGroup): string => {
  const ageGroupLabels = {
    [AgeGroup.CHILDREN]: 'Crianças',
    [AgeGroup.ADULTS]: 'Adultos',
    [AgeGroup.FAMILY]: 'Família',
    [AgeGroup.TEENS]: 'Adolescentes',
    [AgeGroup.SENIORS]: 'Idosos',
  }
  return ageGroupLabels[ageGroup] || ageGroup
}
export const getCategoryColor = (category: ActivityCategory): string => {
  const colors: Record<ActivityCategory, string> = {
    [ActivityCategory.FITNESS]: 'primary',
    [ActivityCategory.SPORTS]: 'primary',
    [ActivityCategory.ENTERTAINMENT]: 'success',
    [ActivityCategory.ADVENTURE]: 'dark',
    [ActivityCategory.AQUATIC]: 'info',
    [ActivityCategory.RECREATION]: 'light',
    [ActivityCategory.WELLNESS]: 'info',
    [ActivityCategory.GASTRONOMY]: 'danger',
    [ActivityCategory.CULTURAL]: 'warning',
    [ActivityCategory.KIDS]: 'secondary',
  }
  return colors[category] || 'secondary'
}
